// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__8D0rx","selects":"Documents_selects__lHRfV"};